import { makeStyles } from '@material-ui/core/styles';

export const useAlertClasses = makeStyles({
  root: {
    borderRadius: 0
  }
});
